import loc from 'owa-localize';
import * as React from 'react';
import showInsertLinkTeachingMoment from '../components/firstRunEvent/showInsertLinkTeachingMoment';
import { observer } from 'mobx-react-lite';
import { IContextualMenuProps } from '@fluentui/react/lib/ContextualMenu';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { insertTooltip } from 'owa-locstrings/lib/strings/attachtooltip.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import { AriaRoles } from 'owa-accessibility';

const styles = require('./InsertMenuItem.scss');
const classNames = require('classnames');

export interface InsertMenuItemProps {
    menu: IContextualMenuProps;
    disabled: boolean;
}

export default observer(function InsertMenuItem(props: InsertMenuItemProps) {
    React.useEffect(() => {
        showInsertLinkTeachingMoment(true);
    }, []);
    const hasNeutralTextColor = isFeatureEnabled('mon-tri-commandbarStyling');
    return (
        <div id="insertMenuItem" className={styles.insertButtonContainer}>
            <CommandBarButton
                role={AriaRoles.menuitem}
                disabled={props.disabled}
                iconProps={{
                    iconName: isFeatureEnabled('doc-attachInsert-cloudLinkIcon')
                        ? ControlIcons.CloudLink
                        : ControlIcons.Link,
                }}
                menuIconProps={{
                    className: hasNeutralTextColor && styles.menuIcon,
                }}
                className={classNames(
                    hasNeutralTextColor && styles.neutralTextColor,
                    styles.insertButton
                )}
                text={loc(insertTooltip)}
                menuProps={props.menu}
            />
        </div>
    );
});
